import { Component } from '@angular/core';
@Component({
  selector: 'prof-internal-user',
  templateUrl: './internal-user.component.html',
  styleUrl: './internal-user.component.scss',
  standalone: false
})
export class InternalUserComponent  {

}
